import { useEffect, useState, memo } from "react";
import { Bar } from "react-chartjs-2";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
Chart.register(CategoryScale);

export const Sectors = memo(({ }) => {
    // const getFiscalMonthNumber = () => {
    //     const currentMonth = new Date().getMonth(); // 0 = Jan, 1 = Feb, ..., 3 = Apr
    //     const fiscalIndex = (currentMonth - 8 + 12) % 12;
    //     const fiscalMonthNumber = ((fiscalIndex + 8) % 12) + 1;
    //     return fiscalMonthNumber.toString(); // For useState
    //   };

    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [filter, setFilter] = useState(0);
    const [filtertext, setFilterText] = useState("");
    const [typeFilter, setTypeFilter] = useState('totalSpent');
    const [isLoading, setIsLoading] = useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [totalrecords, SetTotalRecords] = useState(0);
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [months, setMonths]=useState('9');
    const [weeks,setWeeks]=useState('');
    const [quarter,setQuarter]=useState('');
    const [averageSpentbycus, setAverageSpentbycus] = useState([]);
    const [averageSpent, setAverageSpent] = useState([]); // Store averageSpent in state 
    const weekdays=["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    
    // 
    const today = new Date();
    const currentDayIndex = today.getDay(); 
    const mondayOffset = (currentDayIndex === 0 ? -6 : 1) - currentDayIndex;
    const monday = new Date(today);
    monday.setDate(today.getDate() + mondayOffset);

    const weekMap = weekdays.reduce((acc, day, index) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + index);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    acc[day] = `${yyyy}-${mm}-${dd}`;
    return acc;
    }, {});

    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const fiscalMonthMap = MonthNames.reduce((acc, name, index) => {
        const monthNumber = ((index + 8) % 12) + 1;
        acc[monthNumber] = name;
        return acc;
      }, {});
      const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8
      
      const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
      };
      // Function to get current fiscal quarter based on today's date
        const getCurrentFiscalQuarter = () => {
            const month = new Date().getMonth() + 1; // 1–12
            if (month >= 9 && month <= 11) return 1;   // Sep–Nov
            if (month === 12 || month <= 2) return 2;  // Dec–Feb
            if (month >= 3 && month <= 5) return 3;    // Mar–May
            return 4;                                  // Jun–Aug
        };

        const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => {
            if (selectedFiscalYear === currentFiscalYear) {
                return Number(quarterNumber) <= currentQuarter;
            }
            return true; // show all for past years
            })
            .map(([quarterNumber, label]) => (
            <option key={quarterNumber} value={quarterNumber}>
                {label}
            </option>
            ));
        };
    // Custom plugin to display "No data found"
    const noDataPlugin = {
        id: "noDataPlugin",
        beforeDraw: (chart) => {
            const { datasets } = chart.data;
            const hasData = datasets.some((dataset) => dataset.data.length > 0);

            if (!hasData) {
                const ctx = chart.ctx;
                const { width, height } = chart;

                ctx.save();
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.font = "16px Arial";
                ctx.fillStyle = "#eb9f9d";
                ctx.fillText("Sorry, no data found for your filtered search.", width / 2, height / 2);
                ctx.restore();
            }
        },
    };

    const [topSellerChartData, setTopSellerChartData] = useState({
        labels: [],
        datasets: [
            {
                label: "Top Selling Products",
                data: [],
                type: "bar",
                backgroundColor: [
                    "#EC932F",
                    "#13C2C2",
                    "#1890FF",
                    "#F5222D",
                    "#2F54EB",
                    "#A0D911",
                    "#722ED1",
                    "#EB2F96",
                    "#52C41A",
                    "#FADB14",
                    "#EC932F",
                    "#9E1068",
                    "#0050B3",
                ],
                borderColor: "#e6e6e6",
                borderWidth: 2,
            },
        ],
    });

    const groupBy = (data) => {
        //console.log(data);
        const isGroupedFormat = data[0]?._id && data[0]._id.sector;

        const newarr = isGroupedFormat
          ? data.reduce((acc, d) => {
              const sector = d._id.sector;
              if (!acc[sector]) acc[sector] = [];
              acc[sector].push({
                sum: d.amount,
                orderCount: d.orderCount,
                uniqueClientCount: d.uniqueClientCount,
              });
              return acc;
            }, {})
          : data.reduce((acc, d) => {
              if (!acc[d.sector]) acc[d.sector] = [];
              acc[d.sector].push(d);
              return acc;
            }, {});

        return newarr;

        // return data.reduce((acc, d) => {
        //     if (Object.keys(acc).includes(d.sector)) return acc;
        //     acc[d.sector] = data.filter((g) => g.sector === d.sector);
        //     return acc;
        // }, {});
    };
    
    useEffect(() => {
        if (filter === "weekly" && Object.values(weekMap).length > 0 && !weeks) {
          setWeeks(Object.values(weekMap)[0]);
        }
      }, [filter, weekMap]);

      
    useEffect(() => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const fiscalQuarterMap = {
          9: 1, 10: 1, 11: 1,
          12: 2, 1: 2, 2: 2,
          3: 3, 4: 3, 5: 3,
          6: 4, 7: 4, 8: 4
        };
        const currentFiscalQuarter = fiscalQuarterMap[month];
        setQuarter(currentFiscalQuarter);
      }, []);

    useEffect(() => {
        setIsLoading(true);
        let URL3 = BaseUrl + "admin/sectorsreport";
        if (filter === "custom" && (!fromDate || !toDate)) {
            setIsLoading(false); 
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }
        let payload = {};
        if (filter === "custom") {
            payload = {
                filter: filter,
                datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                dateto: format(new Date(toDate), "yyyy-MM-dd"),
            };
            setShowDatePicker(false);
            } 
            else if (["weekly", "monthly", "quaterly","FYdata"].includes(filter)) 
            {
                payload = {
                    filter: filter,
                    datefrom: "",
                    dateto: "",
                    period: period
                }; 
            } else {
            payload = {
                filter: parseInt(filter),
                datefrom: "",
                dateto: "",
            };
        }

        http
            .post(URL3, payload)
            .then((response) => {
                setIsLoading(false);
                // const monthIndex = MonthNames.indexOf(months);
                // const actualMonth = ((monthIndex + 9) % 12) + 1;
                const actualMonth = parseInt(months);
                
                const filteredData = (filter === 'monthly')? response.data.data.filter(
                   item => item._id.month === actualMonth
                  ) : (filter === 'weekly')? response.data.data.filter(
                    item => item._id.week === weeks
                   ): (filter === 'quaterly')? response.data.data.filter(
                    item => item._id.quarter === quarter): response.data.data;
                 
                const newarr = groupBy(filteredData, "sector");
                const chartData = Object.entries(newarr);
                
                SetTotalRecords(
                    chartData.reduce((sectorAcc, sector) => {
                        const sectorSums = sector[1].reduce(
                            (itemAcc, item) => itemAcc + item.sum,
                            0
                        );
                        return sectorAcc + sectorSums;
                    }, 0)
                );
                
                const totalSpent = chartData.map((item) =>
                    item[1]
                        .reduce((totalr, items) => totalr + items.sum, 0)
                        .toFixed(2)
                );
                
                const averageSpent = chartData.map((item) => {
                    return {
                        amount: item[1]
                            .reduce((totalr, items) => totalr + items.sum, 0)
                            .toFixed(2), orderCount: item[1]
                                .reduce((totalr, items) => totalr + items.orderCount, 0)
                    }
                });
                setAverageSpent(averageSpent);

                const averageSpentbycus = chartData.map((item) => {
                    return {
                        amount: item[1]
                            .reduce((totalr, items) => totalr + items.sum, 0)
                            .toFixed(2), customerCount: (["weekly", "monthly", "quaterly"].includes(filter))? item[1]
                            .reduce((totalr, items) => totalr + items.uniqueClientCount, 0):item[1][0]?.uniqueClientCount || 0
                    }
                });
                setAverageSpentbycus(averageSpentbycus); 
                setTopSellerChartData({
                    labels: chartData.map((item) => item[0]),
                    datasets: [
                        {
                            label: (typeFilter === 'totalSpent' ? "Total Revenue (£)" : typeFilter === 'averageSpent' ? "Average Spend Per Site (£)":"Average Spend Per Customer (£)"),
                            type: "bar",
                            data: (typeFilter === 'totalSpent' ? totalSpent : typeFilter === 'averageSpent' ? averageSpent.map((item) => (item.amount / item.orderCount).toFixed(2)): averageSpentbycus.map((item) => (item.amount / item.customerCount).toFixed(2))),
                            backgroundColor: [
                                "#AFDC8F",
                                "#F8AE54",
                                "#f7b1ae",
                                "#92C5F9",
                                "#B6A6E9",
                                "#42d4f4",
                                "#a9a9a9",
                            ],
                            borderColor: "#f6f6f6",
                            borderWidth: 0,
                            barThickness: 40,
                            maxBarThickness: 60,
                            borderRadius: 4,
                        },
                    ],
                });
                if (filteredData.length === 0) {
                    setTopSellerChartData({
                      labels: [],
                      datasets: [
                        {
                          label: "No Data",
                          type: "bar",
                          data: [],
                          backgroundColor: [],
                        },
                      ],
                    });
                    SetTotalRecords(0);
                    return;
                  }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    }, [filter, fromDate, toDate, typeFilter,period,months,weeks,quarter]);

    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };

    const priceFormat = (price) => {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };

    const changeFilterHandler = (e) => {
        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === "custom") {
            setShowDatePicker(true);
        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);
        }
    };

const changePeriodHandler = (e) => {
  const newPeriod = e.target.value;
  setPeriod(newPeriod); // update selected fiscal year in state
  //split fiscal year
  const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);
  
  const fiscalStartMonthIndex = 8; // 0-based index for September

  const today = new Date();
  const currentFiscalYear = getCurrentFiscalYear();
  //compare sleted year with currentfiscalyear 
  const isCurrentFiscalYear = newPeriod === currentFiscalYear;

  // MONTHLY filter logic
  if (filter === 'monthly') {
    let visibleMonthNames = MonthNames;

    if (isCurrentFiscalYear) {
      // Calculate current fiscal month index 
      const currentMonthIndex = today.getMonth(); // 0-based
      const monthsPassedSinceFiscalStart =
        (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
      const maxVisibleIndex = monthsPassedSinceFiscalStart;

      visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
    }

    const selectedMonthIndex = MonthNames.indexOf(months);
    const isValidMonth =
      selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;

    if (!isValidMonth) {
      const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
      setMonths(String(defaultMonthNumber));
    }
  }

  // QUARTERLY filter logic
  if (filter === 'quarterly') {
    const currentQuarter = getCurrentFiscalQuarter();
    let maxQuarter = 4;

    if (isCurrentFiscalYear) {
      maxQuarter = currentQuarter;
    }

if (parseInt(quarter) > maxQuarter) {
  setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
}

  }
};

    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    };

    const changeTypeFilterHandler = (e) => {
        setTypeFilter(e.target.value);

    };

    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
          }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
     
    let loadingbuffer = isLoading ? "loading-buffer" : "";

    return (
        <div className={`chart-container chart-revenue ${loadingbuffer}`}>
            <div className="chart-Hdr">
                <h2 style={{ textAlign: "left" }}>Sector Revenue Analysis{"  "}</h2>
                <div className="chart-fltr-Hldr">
                <div className="chart-fltr">
                        {
                            <select
                                value={typeFilter}
                                onChange={(e) => changeTypeFilterHandler(e)}
                            >
                                <option value={"totalSpent"}>Total Revenue</option>
                                <option value={"averageSpent"}>Average Spend Per Site</option>
                                <option value={"averageSpentbyCus"}>Average Spend Per Customer</option>
                            </select>
                        }
                </div>
                <div
                    className="chart-fltr"
                    onMouseEnter={() => {
                        if (filter === "custom" && !showDatePicker) {
                            setShowDatePicker(true);
                        }
                    }}
                    onMouseLeave={() => {
                        if (filter === "custom" && showDatePicker) {
                            setShowDatePicker(false);
                        }
                    }}
                >
                    {
                        <select value={filter} onChange={(e) => changeFilterHandler(e)}>
                            <option value={0}>All</option>
                            <option value={"weekly"}>Current Week</option>
                            <option value={"monthly"}>Monthly</option>
                            <option value={"quaterly"}>Quarterly</option>
                            <option value={"FYdata"}>FY Data</option>
                            <option value={30}>Past 30 Days</option>
                            <option value={90}>Past 90 Days</option>
                            <option value={180}>Past 180 Days</option>
                            <option value={365}>Past 1 Year</option>
                            <option value={"custom"}>Custom Date</option>
                        </select>
                    }
                    {showDatePicker && (
                        <div className="date-picker-container">
                            <label>From:</label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => DateChange(date, "from")}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select From Date"
                            />
                            <label>To:</label>
                            <DatePicker
                                selected={toDate}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => DateChange(date, "to")}
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select To Date"
                            />
                        </div>
                    )}

                    {filter === 'weekly' && (
                        <select value={weeks} onChange={(e) => setWeeks(e.target.value)}>
                            {/* {Object.entries(weekMap).map(([dayName, date]) => (
                        <option key={dayName} value={date}>
                            {format(new Date(date), "dd/MM/yyyy")}
                        </option>
                        ))} */}
                        {Object.entries(weekMap).map(([dayName, date]) => {
                                const dateObj = new Date(date);
                                const today = new Date();
                                today.setHours(0, 0, 0, 0); 
                                dateObj.setHours(0, 0, 0, 0); 
                                // Get the start and end date of the current week (Monday to Sunday)
                                const weekStart = new Date(today);
                                const weekEnd = new Date(today);
                                weekStart.setDate(today.getDate() - today.getDay() + 1); // Set to Monday
                                weekEnd.setDate(today.getDate() - today.getDay() + 7); // Set to Sunday
                                if (dateObj < weekStart || dateObj > weekEnd) return null;
                                if (dateObj > today) return null; // Hide future dates
                                return (
                                    <option key={dayName} value={date}>
                                        {format(new Date(date), "dd/MM/yyyy")}
                                    </option>
                                );
                            })}
                        </select>
                    )}

                    {filter === 'quaterly' && (
                    <select
                       
                        value={quarter}
                        onChange={(e) => setQuarter(Number(e.target.value))}
                    >
                       {getAvailableQuarters(period)}
                    </select>
                    )}

                    {filter === 'monthly' && <select value={months} onChange={(e)=>changeMonthHandler(e)}>
                    {/* {Object.entries(fiscalMonthMap).map(([monthNumber, monthName]) => (
                        <option key={monthNumber} value={monthNumber}>
                            {monthName}
                        </option>
                        ))}
                         */}
                         {visibleMonthNames.map((monthName, index) => {
                            const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                            return (
                                <option key={monthNumber} value={monthNumber}>
                                {monthName}
                                </option>
                            );
                            })}
                    </select>

                    }
                    {(filter === 'monthly' || filter === 'quaterly' || filter==='FYdata') &&<select
                        value={period}
                        onChange={(e) => changePeriodHandler(e)}
                    >
                        {options}
                    </select>}
                </div>
                </div>
                <div className="fltr-sub-val">
                    {topSellerChartData && (
                        <span className="fltr-val">
                            Total Amount: <strong>{priceFormat(totalrecords)}</strong> 
                            {(["Current Week", "Monthly", "Quarterly",'FY Data'].includes(filtertext)) ? '' : filtertext != "" && filtertext != "Custom Date"
                                ? ' ('+ filtertext +')'
                                : filtertext === "Custom Date" && fromDate && toDate
                                    ? ' ('+formatDate(fromDate) + " - " + formatDate(toDate)+')'
                                    : ' ('+"All"+')'}
                            
                        </span>
                    )}
                </div>
            </div>
            {topSellerChartData && (
                <Bar
                    data={topSellerChartData}
                    plugins={[noDataPlugin]}
                    // options={options}
                    options={{
                        indexAxis: "y",
                        scales: {
                            y: {
                                grid: {
                                    color: "rgba(247, 243, 241, 0.8)",
                                },
                                ticks: {
                                    color: "rgba(207, 208, 211, 1)",
                                },
                            },
                            x: {
                                grid: {
                                    color: "rgba(247, 243, 241, 0.8)",
                                },
                                ticks: {
                                    color: "rgba(207, 208, 211, 1)",
                                },
                            },
                        },
                        plugins: {
                            title: {
                                display: false,
                                text: "Sector Revenue Chart",
                            },
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                callbacks: {
                                    afterLabel: function (context) {
                                        const sectorIdx = context.dataIndex;
                                        const revenue = typeFilter === "averageSpentbyCus"
                                            ? averageSpentbycus[sectorIdx].amount
                                            : averageSpent[sectorIdx].amount;
                                    
                                        const orderCount = averageSpent[sectorIdx]?.orderCount || 0;
                                        const customerCount = averageSpentbycus[sectorIdx]?.customerCount || 0;
                                    
                                        if (typeFilter === "totalSpent") {
                                            return [
                                                `No. of Orders: ${orderCount}`,
                                                `No. of Customers: ${customerCount}`
                                            ];
                                        }
                                    
                                        if (typeFilter === "averageSpent") {
                                            return [
                                                `Total Revenue (£): ${parseFloat(revenue).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}`,
                                                `No. of Orders: ${orderCount}`
                                            ];
                                        }
                                    
                                        if (typeFilter === "averageSpentbyCus") {
                                            return [
                                                `Total Revenue (£): ${parseFloat(revenue).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}`,
                                                `No. of Customers: ${customerCount}`
                                            ];
                                        }
                                    
                                        return [];
                                    }
                                },
                                titleColor: "rgba(220, 222, 226, 1)",
                                bodyColor: "rgba(220, 222, 226, 1)",
                            },
                            datalabels: {
                                display: false,
                                font: {
                                    size: 11,
                                    weight: "bold",
                                },
                                anchor: "end",
                                align: "end",
                                formatter: function (value) {
                                    return "£" + value;
                                },
                            },
                        },
                    }}
                />
            )}
        </div>
    );
});
